import { createFileRoute, Link } from "@tanstack/react-router";
import { ResourceForm } from "@/components/admin/ResourceForm";

export const Route = createFileRoute("/admin/resources/new")({
  component: NewResource,
});

function NewResource() {
  return (
    <div>
      <Link to="/admin/resources" className="text-sm text-muted-foreground hover:text-foreground">
        ← Back to resources
      </Link>
      <h1 className="mt-3 font-display text-3xl font-semibold tracking-tight text-foreground">
        New resource
      </h1>
      <div className="mt-8">
        <ResourceForm />
      </div>
    </div>
  );
}
